export default "__VITE_ASSET__9831572c__"